<button #originRef (click)="showPopover()" 
  [matBadge]="(badge | async)" [matBadgeHidden]="!(badge | async)" matBadgeSize="small"
  [class.active]="dropdownOpen" class="button" mat-icon-button type="button">
  <mat-icon [icIcon]="icNotificationsActive">
  </mat-icon>
</button>